import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Form, Input, Button, Select } from 'semantic-ui-react'
import "./DomainSearchFilter.css"

class DomainSearchFilter extends Component {

    static propTypes = {
        onSearch: PropTypes.func
    }

    state = {
        filter: {
            searchTerm: '',
            recordTypesToSearch: '',
            domainsToSearch: ''
        }
    }

    onFilterChange = field => (e, { value }) => {
        const filter = { ...this.state.filter, [field]: value };
        this.setState({ filter });
    }

    render() {        
        const { searchTerm, recordTypesToSearch, domainsToSearch } = this.state.filter;
        return (
            <Form>
                <Form.Group widths='equal'>
                    {/* <Form.Select fluid label='Domains' options={domains} placeholder='Domain to Search' onChange={this.onFilterChange('domainsToSearch') />
                    <Form.Select fluid label='Records' options={recordTypes} placeholder='Records to Search' onChange={this.onFilterChange('recordTypesToSearch') /> */}
                    <Form.Input
                        fluid
                        label='Search Term'
                        placeholder='Search term'
                        id='form-input-control-search-term'
                        value={searchTerm}
                        onChange={this.onFilterChange('searchTerm')} />
                    <Form.Button
                        className="search-button"
                        id='form-button-control-public'
                        type="submit"
                        onClick={() => this.props.onSearch(this.state.filter)}>Search</Form.Button>
                </Form.Group>
            </Form>
        );
    }
}

export default DomainSearchFilter;


// WEBPACK FOOTER //
// ./src/components/Filters/DomainSearchFilter/DomainSearchFilter.js